import { useEffect, useRef } from "react";
import { useGroupedAnnouncements, useDismissAnnouncement } from "@/hooks/useTenantAnnouncements";
import { toast } from "sonner";
import { FloatingBanner } from "./FloatingBanner";
import { AnnouncementModal } from "./AnnouncementModal";
import { LoginAnnouncementModal } from "./LoginAnnouncementModal";

export const AnnouncementRenderer = () => {
  const { toasts, modals, floatingBanners, loginAnnouncements } = useGroupedAnnouncements();
  const dismiss = useDismissAnnouncement();
  const shownToastIds = useRef<Set<string>>(new Set());

  // Fire toasts
  useEffect(() => {
    toasts.forEach((a) => {
      if (shownToastIds.current.has(a.id)) return;
      shownToastIds.current.add(a.id);

      const toastType = a.type === "error" ? "error" : a.type === "warning" ? "warning" : a.type === "success" ? "success" : "info";

      if (toastType === "error") {
        toast.error(a.title, { description: a.content, duration: 8000 });
      } else if (toastType === "warning") {
        toast.warning(a.title, { description: a.content, duration: 8000 });
      } else if (toastType === "success") {
        toast.success(a.title, { description: a.content, duration: 5000 });
      } else {
        toast.info(a.title, { description: a.content, duration: 5000 });
      }

      dismiss.mutate({ announcementId: a.id });
    });
  }, [toasts]);

  return (
    <>
      {/* Floating Banners */}
      {floatingBanners.map((a) => (
        <FloatingBanner
          key={a.id}
          announcement={a}
          onDismiss={() => dismiss.mutate({ announcementId: a.id })}
        />
      ))}

      {/* Modal announcements (non-login) */}
      {modals
        .filter((a) => a.trigger_type !== "on_login")
        .slice(0, 1)
        .map((a) => (
          <AnnouncementModal
            key={a.id}
            announcement={a}
            onDismiss={() => dismiss.mutate({ announcementId: a.id })}
            onAcknowledge={() => dismiss.mutate({ announcementId: a.id, acknowledged: true })}
          />
        ))}

      {/* Login announcements */}
      <LoginAnnouncementModal announcements={loginAnnouncements} />
    </>
  );
};
